import React, { createContext, useContext, useEffect, useState } from "react";
import homePageAPI from "../api/homePageApi";
import { useMemo } from "react";
import {
  setAccessToken,
  clearAccessToken,
  getAccessToken,
} from "../api/axiosInstance";
import userAPI from "../api/UserApi";

const SiteConfigContext = createContext();

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      initializeAuth(accessToken);
    }

    const cachedConfig = sessionStorage.getItem("site_config");

    if (cachedConfig) {
      setConfig(JSON.parse(cachedConfig));
      setLoading(false);
    } else {
      fetchSiteDetails();
    }
  }, []);

  const initializeAuth = async (accessToken) => {
    try {
      const res = await userAPI.refreshToken({ accessToken });

      if (res?.code === 200 && res?.data?.access_token) {
        setAccessToken(res.data.access_token);
        localStorage.setItem("accessToken", res.data.access_token);
      } else {
        throw new Error("Invalid refresh response");
      }
    } catch (error) {
      console.log("❌ Auth failed:", error.message);
      clearAccessToken();
      localStorage.removeItem("accessToken");
      localStorage.removeItem("token");
    } finally {
      setLoading(false);
      setIsInitialized(true);
    }
  };

  const fetchSiteDetails = async () => {
    try {
      const res = await homePageAPI.details();

      if (res.code === 200) {
        const decrypted = res.data;
        setConfig(decrypted);
        sessionStorage.setItem("site_config", JSON.stringify(decrypted));
      }
    } catch (err) {
      console.error("Failed to fetch site config", err);
    } finally {
      setLoading(false);
    }
  };

  const siteConfig = useMemo(
    () => ({
      siteName: config?.name || "My Website",
      defaultSEO: {
        title: config?.name || "My Website",
        description:
          config?.metaDescription || "Buy best products online at best price",
        keywords: config?.metaKeywords || "ecommerce, shopping, online store",
        image: config?.logo || "/logo.png",
        url: config?.websiteUrl || window.location.origin,
      },
    }),
    [config],
  );

  return (
    <SiteConfigContext.Provider
      value={{
        config,
        loading,
        siteConfig,
        isInitialized,
        isAuthenticated: !!getAccessToken(),
      }}
    >
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
